import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Smartphone, X, Download } from "lucide-react";

interface FloatingAppDownloadProps {
  className?: string;
}

export const FloatingAppDownload = ({ className }: FloatingAppDownloadProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDownload = () => {
    // For now, this could open app store links or trigger PWA install
    // You can customize this based on your app distribution strategy
    if (navigator.share) {
      navigator.share({
        title: 'Sortable App',
        text: 'Download the Sortable app for the best experience',
        url: window.location.origin,
      });
    } else {
      // Fallback - could open app store or show installation instructions
      window.open(window.location.origin, '_blank');
    }
  };

  return (
    <>
      {/* Main floating button */}
      <div className={`fixed left-4 bottom-4 z-40 ${className}`}>
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-12 h-12 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 bg-primary hover:bg-primary/90"
          size="sm"
          aria-label={isExpanded ? "Close app download menu" : "Open app download menu"}
        >
          {isExpanded ? (
            <X className="h-5 w-5" />
          ) : (
            <Smartphone className="h-5 w-5" />
          )}
        </Button>
      </div>

      {/* Expanded content */}
      {isExpanded && (
        <div className="fixed left-4 bottom-20 z-40">
          <Card className="w-48 shadow-xl border-0 bg-background/95 backdrop-blur-sm">
            <CardContent className="p-4">
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 mx-auto">
                  <Smartphone className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-sm">Get the App</h4>
                  <p className="text-xs text-muted-foreground mt-1">
                    Better experience on mobile
                  </p>
                </div>
                <Button
                  onClick={handleDownload}
                  className="w-full h-8 text-xs"
                  size="sm"
                >
                  <Download className="h-3 w-3 mr-2" />
                  Download
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Backdrop to close when clicking outside */}
      {isExpanded && (
        <div
          className="fixed inset-0 z-30"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </>
  );
};